import "@dxos/node-std/globals"

// packages/common/hypercore/src/crypto.ts
import assert from "@dxos/node-std/assert";
import { callbackify } from "@dxos/node-std/util";
import { verifySignature } from "@dxos/crypto";
var createCodecEncoding = (codec, opts) => ({
  encode: (obj) => Buffer.from(codec.encode(obj, opts)),
  decode: (buffer) => codec.decode(buffer, opts)
});
var createCrypto = (signer, publicKey) => {
  assert(signer);
  assert(publicKey);
  return {
    sign: (message, secretKey, cb) => {
      callbackify(signer.sign.bind(signer))(publicKey, message, (err, result) => {
        if (err) {
          cb(err, null);
          return;
        }
        cb(null, Buffer.from(result));
      });
    },
    verify: async (message, signature, key, cb) => {
      callbackify(verifySignature)(publicKey, message, signature, cb);
    }
  };
};

// packages/common/hypercore/src/defaults.ts
var defaultFeedOptions = {
  createIfMissing: true,
  valueEncoding: "binary"
};
var defaultReadStreamOptions = {
  start: 0,
  end: Infinity,
  snapshot: true,
  tail: false,
  live: false,
  timeout: 0,
  wait: true,
  batch: 1
};
var defaultWriteStreamOptions = {
  maxBlockSize: Infinity
};
var defaultReplicateOptions = {
  live: false,
  ack: false,
  download: true,
  upload: true,
  encrypted: true,
  noise: true
};

// packages/common/hypercore/src/hypercore-factory.ts
import hypercore from "hypercore";
import assert2 from "@dxos/node-std/assert";
import { createStorage, StorageType } from "@dxos/random-access-storage";

// packages/common/hypercore/src/util.ts
import util from "@dxos/node-std/util";
var py = (obj, fn) => util.promisify(fn.bind(obj));

// packages/common/hypercore/src/hypercore-factory.ts
var HypercoreFactory = class {
  // prettier-ignore
  constructor(_root = createStorage({
    type: StorageType.RAM
  }).createDirectory(), _options) {
    this._root = _root;
    this._options = _options;
    assert2(this._root);
  }
  /**
  * Creates a feed using a storage factory prefixed with the feed's key.
  * NOTE: We have to use our `random-access-storage` implementation since the native ones
  * do not behave uniformly across platforms.
  */
  createFeed(publicKey, options) {
    const directory = this._root.createDirectory(publicKey.toString());
    const storage = (filename) => directory.getOrCreateFile(filename).native;
    return hypercore(storage, publicKey, Object.assign({}, this._options, options));
  }
  /**
  * Creates and opens a feed.
  */
  async openFeed(publicKey, options) {
    const feed = this.createFeed(publicKey, options);
    await py(feed, feed.open)();
    return feed;
  }
};

// packages/common/hypercore/src/iterator.ts
import { Readable } from "readable-stream";
var createReadable = (stream) => {
  return new Readable({
    objectMode: true
  }).wrap(stream);
};
var createAsyncIterator = (stream) => {
  return stream[Symbol.asyncIterator]();
};
export {
  HypercoreFactory,
  createAsyncIterator,
  createCodecEncoding,
  createCrypto,
  createReadable,
  defaultFeedOptions,
  defaultReadStreamOptions,
  defaultReplicateOptions,
  defaultWriteStreamOptions
};
//# sourceMappingURL=index.mjs.map
